import { render, staticRenderFns } from "./sanctionsEnforcementsAlertsComponent.vue?vue&type=template&id=798a7816"
import script from "./sanctionsEnforcementsAlertsComponent.vue?vue&type=script&lang=js"
export * from "./sanctionsEnforcementsAlertsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports